export function getCurrentDate(){
  return new Date()
}

export default {
  getCurrentDate
};
